<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container relative">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Công ty/ Đại lý</div>
                <el-select
                  v-model="searchParams.agentID"
                  clearable
                  filterable
                  placeholder="Chọn công ty"
                  placement="bottom-end"
                >
                  <el-option
                    v-for="(item, index) in agentOptions"
                    :key="index"
                    :value="item.id"
                    :label="`(${item.code}) ${item.name || ''}`"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Nguồn</div>
                <el-select
                  v-model="searchParams.sourceId"
                  clearable
                  filterable
                  placeholder="Chọn nguồn"
                >
                  <el-option
                    v-for="(item, index) in sourceOptions"
                    :key="index"
                    :value="item.id"
                    :label="`(${item.code}) ${item.desc}`"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ 'Báo cáo hạn mức' }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              dom-layout="scroll"
              :rows="rows"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Số hóa đơn: Hiển thị số hóa đơn theo phương thức thanh toán bằng
              tiền mặt
            </li>
            <li>Số tiền: Hiển thị số tiền của hóa đơn</li>
            <li>Ngày: Ngày có giao dịch được thanh toán bằng tiền mặt</li>
            <li>
              Tài khoản thu ngân: Tài khoản thực hiện thanh toán bằng tiền mặt
            </li>
            <li>
              Tổng: Hiển thị tổng số tiền của 1 tài khoản thu ngân trong khoảng
              thời gian tìm kiếm
            </li>
            <li>
              Tổng cộng: hiển thị tổng số tiền của tất cả các tài khoản thu ngân
              đã phát sinh giao dịch thanh toán bằng tiền mặt
            </li>
            <li>
              '+-' cho Phép người dùng có thể xem Tổng tiền của từng thu ngân
              hoặc xem chi tiết từng hóa đơn của từng thu ngân
            </li>
            <li style="font-weight: bold">Lưu ý</li>
            <ul>
              <li>
                Với những cột là số tiền: tự động hiển thị dấu phẩy phân tách.
                Ví dụ: 100000(1 trăm) hiển thị: 100,000
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getAllHotel } from '@/api/hotel'
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'
import { formatVND } from '@/utils/commonUtils'
import { getAgent } from '@/api/reception/common.js'
import { getSourceListApi } from '@/api/common/source'
import {
  getLimitReportApi,
  getCashReportExcel
} from '@/api/report_service/datntReport'
import { getAccount } from '@/api/reception/common'

export default {
  components: { DownloadBtn, NoteDialog, CalendarRange },
  data() {
    return {
      searchParams: {
        agentID: null,
        sourceId: null
      },
      defaultSearchParams: {
        agentID: null,
        sourceId: null
      },

      // input
      disableHasInvoice: false,

      // data for search
      agentOptions: [],
      accountRows: [],
      accountCols: [
        {
          headerName: 'Tên',
          field: 'full_name',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Code',
          field: 'code',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],

      columns: [
        {
          headerName: 'STT',
          field: 'no',
          cellClass: 'grid-cell-centered',

          minWidth: 60,
          maxWidth: 60
        },
        {
          headerName: 'Mã công ty/đại lý',
          headerTooltip: 'Mã công ty/đại lý',
          field: 'agent_code',
          tooltipField: 'agent_code',
          autoHeaderHeight: true,
          wrapHeaderText: true,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: 'Công ty/Đại lý',
          headerTooltip: 'Công ty/Đại lý',
          field: 'agent_name',
          tooltipField: 'agent_name',
          autoHeaderHeight: true,
          wrapHeaderText: true,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: 'Nguồn',
          headerTooltip: 'Nguồn',
          field: 'source',
          tooltipField: 'source',
          autoHeaderHeight: true,
          wrapHeaderText: true,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: 'Hạn mức',
          headerTooltip: 'Hạn mức',
          field: 'limit',
          tooltipField: 'limit',
          valueGetter: params => {
            return this.$displayCurrency(params.data.limit)
          },
          cellClass: 'ag-cell-right',
          autoHeaderHeight: true,
          wrapHeaderText: true
        },
        {
          headerName: 'Số ngày nợ cho phép',
          headerTooltip: 'Số ngày nợ cho phép',
          field: 'allow_day',
          tooltipField: 'allow_day',
          cellClass: 'ag-cell-center',
          autoHeaderHeight: true,
          wrapHeaderText: true,
          minWidth: 180,
          maxWidth: 200
        }
      ],
      // grid
      rows: [],
      pinnedBottomRowData: [],

      // dialog
      dialogNoteVisible: false
    }
  },

  watch: {
    'searchParams.invoiceNum'(nv, ov) {
      if (nv) {
        this.disableHasInvoice = true
        this.searchParams.date = {
          start: null,
          end: null
        }
        this.searchParams.accountID = null
        this.searchParams.hotelIds = null
      } else {
        this.disableHasInvoice = false
        this.searchParams = { ...this.defaultSearchParams }
      }
    }
  },

  async mounted() {
    window.rowSpan = params => {
      if (params.data?.rowClass === 'firstRow') {
        return params.data?.countRows
      } else {
        return 1
      }
    }
    window.cellStyle = params => {
      if (params.data?.rowClass === 'firstRow' && params.data?.countRows > 1) {
        return {
          backgroundColor: 'white !important',
          top: 0,
          borderBottom: `1px solid rgba(189, 195, 199, 0.58)`,
          height: `calc(${params.data?.countRows} * ${DEFAULT_GRID_ROW_HEIGHT}px) !important`,
          display: 'flex',
          alignItems: 'center'
        }
      }
      return null
    }
    // window.cellClassRules = {
    //   headerRow: params => params.data?.rowClass === 'headerRow',
    //   groupRow: params => params.data?.rowClass === 'groupRow',
    //   sumRow: params => params.data?.rowClass === 'sumRow'
    // }

    // normal data
    await this.getListAgent()
    await this.getSourceOptions()
    await this.fnGetCashReport()
  },

  methods: {
    onSearch() {
      this.fnGetCashReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.disableHasInvoice = false
      this.fnGetCashReport()
    },
    async getListAgent() {
      var data = await getAgent()
      // getAgent
      this.agentOptions = data.data
    },
    // selectChange(selectedValue) {},
    onSelectAccount(selected) {
      this.searchParams.accountID = selected?.id
    },

    // onDatePickerChange() {
    //   // console.log(this.searchParams.date)
    //   if (this.searchParams.date.end || this.searchParams.date.start) {
    //     this.disableInvoiceNum = true
    //   } else {
    //     this.disableInvoiceNum = false
    //   }
    // },

    // handle api call
    async getListAccount() {
      const res = await getAccount({ department: 'CASHIER' })
      this.accountRows = res.data.map(item => {
        return {
          id: item.account.id,
          code: item.account.code,
          full_name: item.account.full_name
        }
      })
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    exportExcel() {
      const query = {
        invoiceNum: this.searchParams.invoiceNum,
        accountID: this.searchParams.accountID,
        dateFrom: this.searchParams.date.start,
        dateTo: this.searchParams.date.end,
        hotelIds: this.searchParams.hotelIds
      }
      getCashReportExcel(query).then(res => {
        if (res) {
          const date = this.$moment().format('DD-MM-YYYY')
          const href = URL.createObjectURL(res)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute(
            'download',
            'cash_report_' + date + '.xlsx'
            // res.headers['content-disposition'].split('filename=')[1],
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        } else {
          throw new Error(res)
        }
      })
    },
    async getSourceOptions() {
      await getSourceListApi({
        isActive: 1
      }).then(response => {
        this.sourceOptions = response.data
      })
    },
    async fnGetCashReport() {
      try {
        const res = await getLimitReportApi(this.searchParams)
        // console.log(res, '>>Check data')
        this.rows = res.data
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    }
  }
}
</script>
